export default "__VITE_ASSET__CFZFfdRT__"